﻿<template>
    <div v-if="getDay() != ''" class="tc-day">
        <button type="button" class="tc-day-btn departures" :class="{ selected: isDate_Selected() }"
            :aria-pressed="isDate_Selected()" :aria-label="getDay() + ': ' + get_Tours()"
            @click="date_selected()">
            <span class="day-label">{{getDay()}}</span>
            <span class="tc-day-price">{{get_Tours()}}</span>
        </button>
    </div>
</template>

<script lang="ts" src="./calendar_day.ts"></script>